import React from "react";

interface Props {
  colSpan: number;
}

const TableRowNoResults: React.FC<Props> = ({ colSpan }) => {
  return (
    <tr>
      <td
        style={{ fontSize: "16px" }}
        className="text-center"
        colSpan={colSpan}
      >
        No Results
      </td>
    </tr>
  );
};

export default TableRowNoResults;
